module.exports = __webpack_public_path__ + "static/CookieRun-Regular.subset-b99f6742b7f705b5713e4febb48bd1d3.woff";